import React from 'react';
import { Link } from 'react-router-dom';

const MenuItems = ({ parentMenu, secondParentMenu, activeMenu }) => {
  return (
    <ul className="main-menu__list">
      <li className={parentMenu === 'Cartelera' ? 'current-menu-item' : ''}>
        <Link to="/" className={activeMenu === '/' ? 'active-menu' : ''}>
          Cartelera
        </Link>
      </li>
      {window.location.pathname != "/home" && (
      <li className={parentMenu === 'Inicio' ? 'current-menu-item' : ''}>
        <Link to="/home" className={activeMenu === '/home' ? 'active-menu' : ''}>
          Inicio
        </Link>
      </li>
      )}
      {window.location.pathname === "/home" && (
        <li className={parentMenu === 'Talentos' ? 'current-menu-item' : ''}>
          <a href='#th-team' className={activeMenu === '#th-team' ? 'active-menu' : ''} >Talentos</a>
        </li>
      )}
      <li className={parentMenu === 'Contacto' ? 'current-menu-item' : ''}>
        <Link to="/contact" className={activeMenu === '/contact' ? 'active-menu' : ''}>
          Contacto
        </Link>
      </li>
    </ul>
  );
};

export default MenuItems;
